import { render, staticRenderFns } from "./DamagedDeliveryStatus.vue?vue&type=template&id=0f65e3c4&scoped=true&"
import script from "./DamagedDeliveryStatus.vue?vue&type=script&lang=js&"
export * from "./DamagedDeliveryStatus.vue?vue&type=script&lang=js&"
import style0 from "./DamagedDeliveryStatus.vue?vue&type=style&index=0&id=0f65e3c4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f65e3c4",
  null
  
)

export default component.exports